import { Box, Typography } from '@mui/material'
import { FIXTURES_ENABLED } from '@/auth/keycloak'

/**
 * A permanent band across the top. Not dismissible, on purpose.
 *
 * An internal console that looks like the customer product is a screenshot
 * waiting to be mistaken for one — and these screenshots contain numbers that
 * must never be quoted as cash. The band is the cheapest possible marker that
 * survives a crop.
 *
 * Its colour is the environment:
 *   gold   production
 *   blue   development against the real (production) database through the tunnel
 *   RED    fixture mode — DATOS DE MUESTRA. The loudest state, because a
 *          screenshot of sample data escaping into a deck is the worst outcome
 *          this app can produce.
 */
export function InternalBand() {
  const env = import.meta.env.VITE_INTERNAL_ENV ?? 'prod'
  const fixtures = FIXTURES_ENABLED

  const { bg, fg, text } = fixtures
    ? { bg: 'error.main', fg: 'error.contrastText', text: 'INTERNO · FINTELA — DATOS DE MUESTRA' }
    : env === 'dev'
      ? { bg: 'secondary.main', fg: 'secondary.contrastText', text: 'INTERNO · FINTELA — desarrollo (base de PRODUCCIÓN por túnel)' }
      : { bg: 'warning.main', fg: 'warning.contrastText', text: 'INTERNO · FINTELA' }

  return (
    <Box
      sx={{
        // 24px y nada más. Antes eran `height: 24` MÁS un `borderBottom: 4` del
        // MISMO color que el fondo: con `box-sizing: border-box` —que MUI pone
        // globalmente— ese borde no agrandaba la banda, se comía 4 de sus 24 y
        // dejaba el texto en 20. Invisible, porque los dos colores eran el
        // mismo; y cuatro píxeles no son nada hasta que la ventana mide 500 de
        // alto y cada franja fija sale del área que sí se lee.
        height: 24,
        bgcolor: bg,
        color: fg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Typography variant="caption" sx={{ fontWeight: 700, letterSpacing: '0.08em' }}>
        {text}
      </Typography>
    </Box>
  )
}
